import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionComponent from '../../../../components/utils/SectionComponent'
import "./digitalFastEfficient.scss"

function DigitalFastEfficient() {

  const { t } = useTranslation()

  return (
    <div className='container-digital-fast-efficient'>
      <div className="texts-digital-fast-efficient">
        <SectionComponent title={t("ecommerce.fast_efficient.title")}  text={t("ecommerce.fast_efficient.section_text")} />
      </div>
    </div>
  )
}

export default DigitalFastEfficient